<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader @custom-event="getToken"></cnHeader>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/cn">首页</a><span class="space">/</span><a href="/cn/user/index">我的账户</a><span class="space">/</span>订单中心
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
		</div>
		
		<div class="pub_div new_user_center_box">
			
			<!--左侧菜单-开始-->
			<cnUserLeftPannel :fileName="'orders'" :Token="this.token"></cnUserLeftPannel>
			<!--左侧菜单-结束-->
			
			<!--右侧内容-开始-->
			<div class="right_content_box">
				<h1>订单中心</h1>
				
				<!--筛选-开始-->
				<div class="head_box">
					<div class="filter">
						<div class="elem">
							<el-select v-model="orderType" @change="chgOrderType" placeholder="账单类型">
								<el-option
								v-for="item in orderTypeList"
								:key="item.Id"
								:label="item.Title"
								:value="item.Id">
								</el-option>
							</el-select>
						</div>
						<div class="elem">
							<el-select v-model="orderStatus" @change="chgOrderStatus" placeholder="账单状态">
								<el-option
								v-for="item in orderStatusList"
								:key="item.Id"
								:label="item.Title"
								:value="item.Id">
								</el-option>
							</el-select>
						</div>
						<div class="elem" style="width: 250px;">
							<el-input
							  placeholder="请输入账单号"
							  v-model="keyword"
							  maxlength="30"
							  ref="keyword"
							  clearable>
							</el-input>
						</div>
						<div class="elem">
							<div class="btn" @click="searchHandle()">搜索</div>
						</div>
					</div>
					<div class="total"><span v-if="recordTotal>0">共 {{recordTotal}} 条数据</span></div>
				</div>
				<!--筛选-结束-->
				
				<!--无数据-->
				<cnNoData :isShow="noDataIsShow"></cnNoData>
				
				<!--列表-开始-->
				<div class="data_box" v-if="orderList.length>0">
					
					<div class="data_head">
						<ul>
							<li class="txt_left">名称</li>
							<li class="txt_center">类型</li>
							<li class="txt_right">金额</li>
							<li class="txt_center">状态</li>
						</ul>
					</div>
					
					<div class="data_items">
						<ul v-for="(item, index) in orderList" :key="index">
							<li class="txt_left title">
								<div class="picture">
									<a :href="'/cn/'+item.SourcePath+'/detail?Id='+item.SourceDataId" target="_blank"><img :src="item.Picture" /></a>
								</div>
								<div class="od_text">
									<h5><a :href="'/cn/'+item.SourcePath+'/detail?Id='+item.SourceDataId" target="_blank">{{truncatedMessage(item.Title,60)}}</a></h5>
									<p>订单号：<a :href="'/cn/user/order_detail?OrderNo='+item.OrderNo" target="_blank"><b>{{item.OrderNo}}</b></a>　　下单时间：{{item.Time}}</p>
								</div>
							</li>
							<li class="txt_center">{{item.OrderType}}</li>
							<li class="txt_right">${{item.PayablePrice}}</li>
							<li class="txt_center"><span :class="'status_'+item.Status">{{item.StatusText}}</span></li>
						</ul>
					</div>
					
				</div>
				<!--列表-结束-->
				
				<!--分页-开始-->
				<div class="page_ctrl" v-if="this.orderList.length>0 && pageTotal>1">
					<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
						:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
				<!--分页-结束-->
			</div>
			<!--右侧内容-结束-->
			
		</div>
		
		<cnFooter></cnFooter>
	</div>
</template>

<script>
	import {
		checkToken,
		getOrderType,
		getOrderStatus,
		getOrder,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	import cnNoData from '@/components/cn_noData.vue'
	import cnUserLeftPannel from '@/components/cn_user_left_pannel.vue'
	export default {
		name: 'CN_UserOrders',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
			cnNoData,
			cnUserLeftPannel,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				noDataIsShow: false, //无数据缺省
				language: 'cn', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				
				orderType:'',
				orderTypeList: [],
				
				orderStatus:'',
				orderStatusList: [],
				
				pageIndex: 1, 		//页码，默认为1
				pageSize: 10, 		//每页显示条数
				pageTotal: 0, 		//总页数
				recordTotal: 0, 	//总条数
				
				orderList: [],
				
				keyword:''
			}
		},
		created() {
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					
					this.getOrderTypeList()
				}
				else				
				{
					this.$router.push({
						path: '/cn/user/login'
					})
				}
			},
			// 获取订单类型
			async getOrderTypeList() {
				const { data: res } = await getOrderType(this.language)
				if (res.errcode === 0) {
					this.orderTypeList = res.data
					if(this.orderTypeList.length>0)
					{
						this.orderType = this.orderTypeList[0].Id
					}
					
					// 获取订单状态
					this.getOrderStatusList()
				} else {
					this.$message.error(res.errmsg);
				}
			},			
			// 获取订单状态
			async getOrderStatusList() {
				const { data: res } = await getOrderStatus(this.language)
				if (res.errcode === 0) {
					this.orderStatusList = res.data
					
					//获取订单状态
					this.getData()
				} else {
					this.$message.error(res.errmsg);
				}
			},	
			//获取数据
			async getData() {
				this.orderList = []
				this.fullscreenLoading = true
				const { data: res } = await getOrder(this.language, this.token, this.terminal, this.orderType, this.orderStatus, this.keyword, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					
					if(res.data != null)
					{
						this.orderList = res.data.DataList
						this.pageTotal = res.data.PageTotal
						this.recordTotal = res.data.RecordTotal
						if (res.data.DataList.length > 0) {
							this.noDataIsShow = false
							this.$nextTick(() => {
								window.scrollTo(0, 0);
							});
						} else {
							this.noDataIsShow = true
						}
					}
					else{
						this.noDataIsShow = true
					}
					
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
			// 类型切换
			chgOrderType(val)
			{
				this.orderType = val
				this.pageIndex = 1
				this.getData()
			},
			// 状态切换
			chgOrderStatus(val)
			{
				this.orderStatus = val
				this.pageIndex = 1
				this.getData()
			},
			// 搜索
			searchHandle()
			{
				this.pageIndex = 1
				this.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.head_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			
			.total {
				font-size: 13px;
			}
			
			.filter {
				display: flex;
				
				.elem {
					margin-right: 14px;
				}
				
				.btn {
					height: 40px;
					line-height: 40px;
					box-sizing: border-box;
					background-color: #3D7856;
					color: #fff;
					background-image: url(@/assets/images/icons/man_search.png);
					background-position: 15px center;
					background-repeat: no-repeat;
					background-size: 16px 16px;
					border-radius: 5px;
					padding: 0 15px 0 35px;
					cursor: pointer;
					-webkit-transition: all .3s ease;
				}
				.btn:hover {
					background-color: #000;
				}
			}
		}
		
		.data_box {
			
			margin-top: 30px;
			
			ul {
				display: flex;
				align-items: center;
			}
			li {
				box-sizing: border-box;
				font-size: 14px;
				font-weight: 500;
				line-height: 48px;
				padding: 0 12px;
			}
			li.txt_left {
				width: 64%;
			}
			li.txt_center {
				width: 12%;
				text-align: center;
			}
			li.txt_right {
				width: 12%;
				text-align: right;
			}
			
			.data_head {
				height: 48px;
				box-sizing: border-box;
				background-color: #F1F1F1;
				border-radius: 5px;
			}
			
			.data_items {
				
				ul {
					border-bottom: #DFE0E4 solid 1px;
					padding: 24px 0;
				}
				
				li {
					font-weight: 400;
					line-height: 140%;
					
					
					.status_1 {
						color: #000;
					}
					.status_2 {
						color: #3166DD;
					}
					.status_3 {
						color: #00A419;
					}
					.status_4 {
						color: #ff3300;
					}
					.status_5,.status_6 {
						color: #666;
					}
					.status_7 {
						color: #8D00B1;
					}
				}
				li.title {
					display: flex;
					justify-content: space-between;
					
					.picture {
						width: 105px;
						
						img {
							width: 100%;
							height: 70px;
							border-radius: 8px;
							display: block;
						}
					}
					.od_text {
						width: 80%;
						
						h5 {
							font-size: 13px;
							font-weight: 500;
							
							a {
								text-decoration: underline;
								color: #000;
							}
							a:hover {
								color: #3D7856;
							}
						}
						p {
							margin-top: 10px;
							font-size: 12px;
							line-height: 140%;
							
							a {
								text-decoration: underline;
								color: #3D7856;
							}
							a:hover {
								color: #000;
							}
						}
					}
				}
			}
		}
		
		.items_box {
			display: flex;
			flex-wrap: wrap;
			margin-top: 40px;
			
			.item {
				width: 660px;
				height: 180px;
				position: relative;
				overflow: hidden;
				box-sizing: border-box;
				padding: 20px;
				background-color: #F7F7F7;
				border-radius: 8px;
				margin:0 30px 30px 0;
				display: flex;
				-webkit-transition: all .3s ease;
				
				a {
					color: #008768;
					text-decoration: underline;
				}
				
				.picture {
					position: relative;
					margin-right: 16px;
					
					img {
						width: 208px;
						height: 140px;
						border-radius: 8px;
						display: block;
					}
					.tag {
						position: absolute;
						bottom: 0;
						right: 0;
						z-index: 100;
						height: 32px;
						line-height: 32px;
						font-size: 13px;
						background-color: #000;
						color: #fff;
						padding: 0 12px;
						border-top-left-radius: 8px;
						border-bottom-right-radius: 8px;
					}
				}
				.information {
					width: 100%;
					position: relative;
					
					.tag {
						position: absolute;
						top: -6px;
						right: -6px;
						height: 28px;
						line-height: 28px;
						font-size: 12px;
						background-color: #fff;
						border-radius: 3px;
						padding: 0 12px;
						display: block;
					}
					.status_1 {
						color: #000;
					}
					.status_2 {
						color: #3166DD;
					}
					.status_3 {
						color: #00A419;
					}
					.status_4 {
						color: #ff3300;
					}
					.status_5,.status_6 {
						color: #666;
					}
					.status_7 {
						color: #8D00B1;
					}
					
					p {
						font-size: 13px;
						margin-top: 6px;
					}
					
					.title {
						position: relative;
						overflow: hidden;
						height: 40px;
					}
					.price {
						font-size: 16px;
					}
				}
			}
			.item:nth-child(even)
			{
				margin-right: 0px;
			}
			.item:hover {
				background-color: #F5F7FA;
				box-shadow: 2px 2px 8px #eee;
			}
		}
		
		/deep/ .el-select {
			width: 100%;
			border: #C4C4C4 solid 1px;
			border-radius: 5px;
			background-color: #fff;
			background-image: none;
			font-size: 15px;
			font-weight: 500;
			color: #000;
			
			.el-input__inner {
				border: 0;
			}
		}
		
		
		/*输入框*/
		.el-input {
			width: 100%;
			border: #C4C4C4 solid 1px;
			border-radius: 5px;
			background-color: #fff;
			background-image: none;
			font-size: 15px;
		}
		/deep/ .el-input__inner {
			background-image: none;
			font-weight: 400;
		}
		
		/*按钮*/
		.el-button {
			width: 130px;
			font-family: "PingFang SC", sans-serif, Helvetica, Arial;
			font-size: 15px;
			font-weight: 400;
			height: 42px;
			border-radius: 21px;
		}
		.el-button--default {
			border: #3D7856 solid 1px;
			color: #3D7856;
			margin-left: 20px;
			border-radius: 8px;
		}
		.el-button--default:hover {
			border: #3D7856 solid 1px;
			color: #3D7856;
		}
		.el-button.is-plain:focus  {
			border: #3D7856 solid 1px;
			color: #3D7856;
		}
		
		.el-button--primary {
			border: 0;
			border-radius: 8px;
		}		
		.el-button--primary:focus {
			background-color: #3D7856;
		}
		.el-button--primary:hover {
			background-color: #000;
		}
		
		
		/deep/ .el-pagination {
			font-size: 16px;
		}
		
		/deep/ .el-pager li {
			width: 36px;
			height: 36px;
			font-size: 16px;
			line-height: 36px;
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #3D7856;
			font-size: 16px;
		}
		
		/deep/ .el-pagination button {
			width: 36px;
			height: 36px;	
			border-radius: 5px;
		}
		
		/deep/ .el-pagination .btn-next .el-icon {
			font-size: 16px;
		}
		/deep/ .el-pagination .btn-prev .el-icon {			
			font-size: 16px;
		}
	}
</style>